import React, { Component } from "react";
import { withStore } from "../../component/hooks/store";
import { withStyles } from "@material-ui/core/styles";
import Styles from "../../styles/admin/players";
import Button from "../../component/button";
// import ReactFileReader from 'react-file-reader';
import {
  checkNullAndReturnString,
  doGetConnectSecurity,
  doPostConnectSecurity,
  doGetConnect,
} from "../../helper/common";
import SelectBox from "../../component/selectBox";
import { toast } from "react-toastify";
import { Modal } from "react-responsive-modal";
import Loading from "../../component/loading";
// import axios from "axios";
// import fileDownload from "js-file-download";
// import Config from "../../helper/config";

class ImportStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      school: 0,
      academicYear: [{ label: "Academic Year", value: 0 }],
      schoolDetails: [{ label: "school", value: 0 }],
      modal: false,
      draftData: false,
      draftId: "",
      sampleSelectedData: [],
      tableData: [],
      tableLoadData: [],
      importData: false,
      fileName: "",
      modalpaginations: {
        paginatonpageindex: 0,
        paginationrowsPerPage: 50,
        paginationcountdata: 100,
      },
      loading: false,
      schoolId: 0,
      // schoolCheckBox: false,
      showNotifyModal: false,
      exportModal: false,
    };
  }

  onOpenModal = () => {
    this.setState({ modal: true });
  };

  onCloseModal = () => {
    this.setState({ modal: false });
  };

  componentDidMount = async () => {
    this.getAcademicYear();
    this.getSchoolDetails();
    if (this.props.hashEmail) {
      this.getHashData(this.props.hashEmail);
    }
  };

  getHashData = async (hashEmail) => {
    var accessToken = localStorage.getItem("accessToken");
    var responseData = await doGetConnectSecurity(
      "ncaa/ncaa-json?hash=" + hashEmail,
      accessToken
    );
    if (responseData.data) {
      if (responseData.data[0]) {
        this.setState({ school: responseData.data[0].year });
        if (responseData.data[0].ncaaperiod) {
          let samplec = await this.statisticDataModifier(
            responseData.data[0].ncaaperiod
          );
          this.setState(
            {
              sampleSelectedData: samplec,
              tableData: [],
              tableLoadData: [],
              fileName: "",
              importData: false,
            },
            this.setImportdata
          );
        }
      }
    }
  };

  async getSchoolDetails() {
    var responseData = await doGetConnect("school?emailDomain=true");
    if (checkNullAndReturnString(responseData)) {
      if (checkNullAndReturnString(responseData.data)) {
        var schoolData = [{ label: "School", value: 0 }];
        var responseSchoollData = JSON.parse(
          JSON.stringify(responseData.data).split('"id":').join('"value":')
        );
        responseSchoollData = JSON.parse(
          JSON.stringify(responseSchoollData)
            .split('"school_name":')
            .join('"label":')
        );
        var schoolList = schoolData.concat(responseSchoollData);
        this.setState({ schoolDetails: schoolList });
      }
    }
  }

  getAcademicYear = async () => {
    var academicYear = [{ label: "Academic Year", value: 0 }];
    var responseData = await doGetConnect("academic-year");
    if (checkNullAndReturnString(responseData)) {
      if (checkNullAndReturnString(responseData.data)) {
        var academicYearData = responseData.data;
        Object.keys(academicYearData).forEach((key) => {
          academicYear.push({
            label: academicYearData[key].year,
            value: academicYearData[key].year,
          });
        });
        this.setState({ academicYear });
      }
    }
  };

  emptyData = () => {
    this.setState({
      tableData: [],
      setImportdata: [],
      tableLoadData: [],
      importData: false,
      fileName: "",
      school: 0,
      // tableLoadData: [],
      modalpaginations: {
        paginatonpageindex: 0,
        paginationrowsPerPage: 50,
        paginationcountdata: 0,
      },
    });
  };

  handleChange = async (id, value) => {
    this.setState({
      [id]: value,
      tableData: [],
      setImportdata: [],
      tableLoadData: [],
      importData: false,
      fileName: "",
      // tableLoadData: [],
      modalpaginations: {
        paginatonpageindex: 0,
        paginationrowsPerPage: 50,
        paginationcountdata: 0,
      },
    });
  };

  exportDataStatistics = async () => {
    const year = this.state.school;
    if (!checkNullAndReturnString(year) || year === 0) {
      toast.error("Please select academic year");
      return;
    }
    this.setState({
      loading: true,
    });
    var accessToken = localStorage.getItem("accessToken");
    await doGetConnectSecurity(
      `ncaa-player-statistics/exportAsExcel?academicYear=${year}&sortby=school_id&order=ASC`,
      accessToken
    )
      .then((res) => {
        if (res?.error) {
          toast.error("No statistics data found to export");
        } else {
          this.setState({ exportModal: true });
        }
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        toast.error("No statistics data found to export");
      });
    // var accessToken = localStorage.getItem("accessToken");
    // await axios({
    //   method: "GET",
    //   url: `${Config.dataUrl}player-statistics/exportAsExcel?academicYear=${year}&sortby=school_id&order=ASC`,
    //   data: {},
    //   responseType: "blob",
    //   headers: {
    //     Authorization: "Bearer " + accessToken,
    //   },
    // })
    //   .then((res) => {
    //     this.setState({
    //       loading: false,
    //     });
    //     this.setState({ exportModal: true });
    //     fileDownload(res.data, "PlayerStatistics.xls");
    //   })
    //   .catch((err) => {
    //     this.setState({
    //       loading: false,
    //     });
    //     toast.error("No statistics data found to export");
    //   });
  };

  importDataStatistics = async () => {
    const year = this.state.school;
    if (!checkNullAndReturnString(year) || year === 0) {
      toast.error("Please select academic year");
      return;
    }
    try {
      this.setState({
        loading: true,
      });
      var accessToken = localStorage.getItem("accessToken");
      var responseData = await doPostConnectSecurity(
        "ncaa-sports/statistics",
        {
          year,
        },
        accessToken
      );
      if (checkNullAndReturnString(responseData)) {
        if (checkNullAndReturnString(responseData.message)) {
          // toast.success(responseData.message);
          this.setState({ showNotifyModal: true });
        }
        this.setState({
          loading: false,
        });
      }
    } catch ({ error }) {
      this.setState({
        loading: false,
      });
      if (checkNullAndReturnString(error)) {
        if (checkNullAndReturnString(error.message)) {
          toast.error(error.message);
        }
      }
    }
  };

  statisticDataModifier = (playerStatistics) => {
    return new Promise((resolve) => {
      let samplec = [];
      for (
        var singleRow = 0;
        singleRow < playerStatistics.length;
        singleRow++
      ) {
        const ele = playerStatistics[singleRow] || {};

        const zero = 0;
        const emptystring = "";

        var sequence_data = {
          id: ele.id || singleRow + 1,
          first_name: ele.firstName || emptystring,
          last_name: ele.familyName || emptystring,
          // team: (ele.team || emptystring),
          academic_year: this.state.school || emptystring,
          class: ele.class || emptystring,
          position: ele.defaultPlayingPosition || emptystring,
          person_id: ele.personId.toString() || emptystring,
          city: ele.city || emptystring,
          state: ele.state || emptystring,
          sport: ele.leagueId || emptystring,
          // school_id: (ele.school_id || emptystring),
          teamName: ele.teamName || emptystring,
          teamId: ele.teamId || emptystring,
          // gender: (ele.gender || emptystring),
          // dob: (ele.dob || emptystring),
          familyName: ele.familyName || emptystring,
          personName: ele.personName || emptystring,
          // personNameInternational: (ele.personNameInternational || emptystring),
          // personGsId: (ele.personGsId || emptystring),
          // TVName: (ele.TVName || emptystring),
          // scoreboardName: (ele.scoreboardName || emptystring),
          // website: (ele.website || emptystring),
          // nickName: (ele.nickName || emptystring),
          // internationalReference: (ele.internationalReference || emptystring),
          // internationalFirstName: (ele.internationalFirstName || emptystring),
          // internationalFamilyName: (ele.internationalFamilyName || emptystring),
          defaultShirtNumber: ele.defaultShirtNumber || emptystring,
          defaultPlayingPosition: ele.defaultPlayingPosition || emptystring,
          personExternalId: ele.personExternalId || emptystring,
          s1stDownAttempts: ele.s1stDownAttempts || zero,
          s1stDownConversions: ele.s1stDownConversions || zero,
          s2ndDownAttempts: ele.s2ndDownAttempts || zero,
          s2ndDownConversions: ele.s2ndDownConversions || zero,
          s3rdDownAttempts: ele.s3rdDownAttempts || zero,
          s3rdDownConversionPassing: ele.s3rdDownConversionPassing || zero,
          s3rdDownConversionPenalty: ele.s3rdDownConversionPenalty || zero,
          s3rdDownConversionRushing: ele.s3rdDownConversionRushing || zero,
          s3rdDownConversions: ele.s3rdDownConversions || zero,
          s4thDownAttempts: ele.s4thDownAttempts || zero,
          s4thDownConversionPassing: ele.s4thDownConversionPassing || zero,
          s4thDownConversionPenalty: ele.s4thDownConversionPenalty || zero,
          s4thDownConversionRushing: ele.s4thDownConversionRushing || zero,
          s4thDownConversions: ele.s4thDownConversions || zero,
          sDefensiveExtraPoints: ele.sDefensiveExtraPoints || zero,
          sDefensiveExtraPointsAttempts:
            ele.sDefensiveExtraPointsAttempts || zero,
          sDraws: ele.sDraws || zero,
          sDrawsAverage: ele.sDrawsAverage || zero,
          sEfficiency: ele.sEfficiency || zero,
          sEfficiencyCustom: ele.sEfficiencyCustom || zero,
          sFieldGoalAttemptLongest: ele.sFieldGoalAttemptLongest || zero,
          sFieldGoalAttempts1to19: ele.sFieldGoalAttempts1to19 || zero,
          sFieldGoalAttempts20to29: ele.sFieldGoalAttempts20to29 || zero,
          sFieldGoalAttempts30to39: ele.sFieldGoalAttempts30to39 || zero,
          sFieldGoalAttempts40to49: ele.sFieldGoalAttempts40to49 || zero,
          sFieldGoalAttempts50to59: ele.sFieldGoalAttempts50to59 || zero,
          sFieldGoalAttempts60Plus: ele.sFieldGoalAttempts60Plus || zero,
          sFieldGoalMadeLongest: ele.sFieldGoalMadeLongest || zero,
          sFieldGoalReturns: ele.sFieldGoalReturns || zero,
          sFieldGoalsAttempted: ele.sFieldGoalsAttempted || zero,
          sFieldGoalsBlocked: ele.sFieldGoalsBlocked || zero,
          sFieldGoalsBlockedBy: ele.sFieldGoalsBlockedBy || zero,
          sFieldGoalsMade: ele.sFieldGoalsMade || zero,
          sFieldGoalsMade1to19: ele.sFieldGoalsMade1to19 || zero,
          sFieldGoalsMade20to29: ele.sFieldGoalsMade20to29 || zero,
          sFieldGoalsMade30to39: ele.sFieldGoalsMade30to39 || zero,
          sFieldGoalsMade40to49: ele.sFieldGoalsMade40to49 || zero,
          sFieldGoalsMade50to59: ele.sFieldGoalsMade50to59 || zero,
          sFieldGoalsMade60Plus: ele.sFieldGoalsMade60Plus || zero,
          sFieldGoalsPercentage: ele.sFieldGoalsPercentage || zero,
          sFirstDownPassing: ele.sFirstDownPassing || zero,
          sFirstDownPenalty: ele.sFirstDownPenalty || zero,
          sFirstDownRushing: ele.sFirstDownRushing || zero,
          sFirstDownTotal: ele.sFirstDownTotal || zero,
          sForfeitsAgainst: ele.sForfeitsAgainst || zero,
          sForfeitsAgainstAverage: ele.sForfeitsAgainstAverage || zero,
          sForfeitsFor: ele.sForfeitsFor || zero,
          sForfeitsForAverage: ele.sForfeitsForAverage || zero,
          sFumbleReturnLongest: ele.sFumbleReturnLongest || zero,
          sFumbleReturnTotal: ele.sFumbleReturnTotal || zero,
          sFumbleReturnTouchdowns: ele.sFumbleReturnTouchdowns || zero,
          sFumbleReturnYards: ele.sFumbleReturnYards || zero,
          sFumbleReturnYardsAverage: ele.sFumbleReturnYardsAverage || zero,
          sFumblesForced: ele.sFumblesForced || zero,
          sFumblesLost: ele.sFumblesLost || zero,
          sFumblesRecovered: ele.sFumblesRecovered || zero,
          sFumblesTotal: ele.sFumblesTotal || zero,
          sGames: ele.sGames || zero,
          sGamesStarted: ele.sGamesStarted || zero,
          sGamesStartedAverage: ele.sGamesStartedAverage || zero,
          sGamesTeam: ele.sGamesTeam || zero,
          sGamesTeamAverage: ele.sGamesTeamAverage || zero,
          sGamesTeamPercentage: ele.sGamesTeamPercentage || zero,
          sGamesTeamPercentageAverage: ele.sGamesTeamPercentageAverage || zero,
          sGoalEfficiencyAttempt: ele.sGoalEfficiencyAttempt || zero,
          sGoalEfficiencyFieldGoal: ele.sGoalEfficiencyFieldGoal || zero,
          sGoalEfficiencyPercentage: ele.sGoalEfficiencyPercentage || zero,
          sGoalEfficiencyTouchdowns: ele.sGoalEfficiencyTouchdowns || zero,
          sInterceptionsAverage: ele.sInterceptionsAverage || zero,
          sInterceptionsReturnLongest: ele.sInterceptionsReturnLongest || zero,
          sInterceptionsReturnYards: ele.sInterceptionsReturnYards || zero,
          sInterceptionsTouchdowns: ele.sInterceptionsTouchdowns || zero,
          sKickoffsGrossAverage: ele.sKickoffsGrossAverage || zero,
          sKickoffsGrossYards: ele.sKickoffsGrossYards || zero,
          sKickoffsNetAverage: ele.sKickoffsNetAverage || zero,
          sKickoffsNetYards: ele.sKickoffsNetYards || zero,
          sKickoffsOutOfBound: ele.sKickoffsOutOfBound || zero,
          sKickoffsReturned: ele.sKickoffsReturned || zero,
          sKickoffsTotal: ele.sKickoffsTotal || zero,
          sKickoffsTouchbacks: ele.sKickoffsTouchbacks || zero,
          sKickOnSideAttempts: ele.sKickOnSideAttempts || zero,
          sKickReturnsAverage: ele.sKickReturnsAverage || zero,
          sKickReturnsLongest: ele.sKickReturnsLongest || zero,
          sKickReturnsTotal: ele.sKickReturnsTotal || zero,
          sKickReturnsTouchdowns: ele.sKickReturnsTouchdowns || zero,
          sKickReturnsYards: ele.sKickReturnsYards || zero,
          sKicksBlocked: ele.sKicksBlocked || zero,
          sKicksBlockedBy: ele.sKicksBlockedBy || zero,
          sKicksOnSide: ele.sKicksOnSide || zero,
          sLosses: ele.sLosses || zero,
          sLossesAverage: ele.sLossesAverage || zero,
          sMinutes: ele.sMinutes || zero,
          sMinutesAverage: ele.sMinutesAverage || zero,
          sPassBreakUps: ele.sPassBreakUps || zero,
          sPassEfficiency: ele.sPassEfficiency || zero,
          sPasses: ele.sPasses || zero,
          sPassesAverageYardsPerCompletion:
            ele.sPassesAverageYardsPerCompletion || zero,
          sPassesCompleted: ele.sPassesCompleted || zero,
          sPassesIntercepted: ele.sPassesIntercepted || zero,
          sPassesInterceptionPercentage:
            ele.sPassesInterceptionPercentage || zero,
          sPassesLeft: ele.sPassesLeft || zero,
          sPassesLongest: ele.sPassesLongest || zero,
          sPassesMiddle: ele.sPassesMiddle || zero,
          sPassesPercentage: ele.sPassesPercentage || zero,
          sPassesRight: ele.sPassesRight || zero,
          sPassesSacked: ele.sPassesSacked || zero,
          sPassesTouchDownPercentage: ele.sPassesTouchDownPercentage || zero,
          sPassesTouchdowns: ele.sPassesTouchdowns || zero,
          sPassesYards: ele.sPassesYards || zero,
          sPassesYardsAverage: ele.sPassesYardsAverage || zero,
          sPassesYardsPerAttempt: ele.sPassesYardsPerAttempt || zero,
          sPassesYardsPerCatch: ele.sPassesYardsPerCatch || zero,
          sPassesYardsSacked: ele.sPassesYardsSacked || zero,
          sPassIncompleteDropped: ele.sPassIncompleteDropped || zero,
          sPassing0: ele.sPassing0 || zero,
          sPassing10: ele.sPassing10 || zero,
          sPassing20: ele.sPassing20 || zero,
          sPassing30: ele.sPassing30 || zero,
          sPassing40: ele.sPassing40 || zero,
          sPassing50: ele.sPassing50 || zero,
          sPassingNegative: ele.sPassingNegative || zero,
          sPassInterceptions: ele.sPassInterceptions || zero,
          sPassQuarterbackHurries: ele.sPassQuarterbackHurries || zero,
          sPatAttempts: ele.sPatAttempts || zero,
          sPatBlockedKicks: ele.sPatBlockedKicks || zero,
          sPatBlockedKicksBy: ele.sPatBlockedKicksBy || zero,
          sPatFumbleReturnConversions: ele.sPatFumbleReturnConversions || zero,
          sPatFumbleReturns: ele.sPatFumbleReturns || zero,
          sPatInterceptionReturnConversions:
            ele.sPatInterceptionReturnConversions || zero,
          sPatInterceptionReturns: ele.sPatInterceptionReturns || zero,
          sPatKickReturnConversions: ele.sPatKickReturnConversions || zero,
          sPatKickReturns: ele.sPatKickReturns || zero,
          sPatKicksAttempted: ele.sPatKicksAttempted || zero,
          sPatKicksMade: ele.sPatKicksMade || zero,
          sPatKicksPercentage: ele.sPatKicksPercentage || zero,
          sPatMade: ele.sPatMade || zero,
          sPatPassAttempts: ele.sPatPassAttempts || zero,
          sPatPasses: ele.sPatPasses || zero,
          sPatPercentage: ele.sPatPercentage || zero,
          sPatReceives: ele.sPatReceives || zero,
          sPatRushAttempts: ele.sPatRushAttempts || zero,
          sPatRushes: ele.sPatRushes || zero,
          sPatSafetyConversions: ele.sPatSafetyConversions || zero,
          sPatTwoPointsAttempt: ele.sPatTwoPointsAttempt || zero,
          sPatTwoPointsMade: ele.sPatTwoPointsMade || zero,
          sPenalty: ele.sPenalty || zero,
          sPenaltyYards: ele.sPenaltyYards || zero,
          sPlaysAllPurposeTotal: ele.sPlaysAllPurposeTotal || zero,
          sPlaysTotal: ele.sPlaysTotal || zero,
          sPoints: ele.sPoints || zero,
          sPointsAverage: ele.sPointsAverage || zero,
          sPuntReturns: ele.sPuntReturns || zero,
          sPuntReturns0: ele.sPuntReturns0 || zero,
          sPuntReturns10: ele.sPuntReturns10 || zero,
          sPuntReturns20: ele.sPuntReturns20 || zero,
          sPuntReturns30: ele.sPuntReturns30 || zero,
          sPuntReturns40: ele.sPuntReturns40 || zero,
          sPuntReturns50: ele.sPuntReturns50 || zero,
          sPuntReturnsAverage: ele.sPuntReturnsAverage || zero,
          sPuntReturnsLongest: ele.sPuntReturnsLongest || zero,
          sPuntReturnsTouchdown: ele.sPuntReturnsTouchdown || zero,
          sPuntReturnsYards: ele.sPuntReturnsYards || zero,
          sPunts: ele.sPunts || zero,
          sPunts50plus: ele.sPunts50plus || zero,
          sPuntsAverage: ele.sPuntsAverage || zero,
          sPuntsBlocked: ele.sPuntsBlocked || zero,
          sPuntsBlockedBy: ele.sPuntsBlockedBy || zero,
          sPuntsFairCatches: ele.sPuntsFairCatches || zero,
          sPuntsInside20: ele.sPuntsInside20 || zero,
          sPuntsLongest: ele.sPuntsLongest || zero,
          sPuntsNetAverage: ele.sPuntsNetAverage || zero,
          sPuntsTouchbacks: ele.sPuntsTouchbacks || zero,
          sPuntsYards: ele.sPuntsYards || zero,
          sPuntsYardsNet: ele.sPuntsYardsNet || zero,
          sReceiving0: ele.sReceiving0 || zero,
          sReceiving10: ele.sReceiving10 || zero,
          sReceiving20: ele.sReceiving20 || zero,
          sReceiving30: ele.sReceiving30 || zero,
          sReceiving40: ele.sReceiving40 || zero,
          sReceiving50: ele.sReceiving50 || zero,
          sReceivingNegative: ele.sReceivingNegative || zero,
          sReceptions: ele.sReceptions || zero,
          sReceptionsAverage: ele.sReceptionsAverage || zero,
          sReceptionsLongest: ele.sReceptionsLongest || zero,
          sReceptionsTouchdown: ele.sReceptionsTouchdown || zero,
          sReceptionsYards: ele.sReceptionsYards || zero,
          sReceptionsYardsAfterCatch: ele.sReceptionsYardsAfterCatch || zero,
          sReceptionsYardsAverage: ele.sReceptionsYardsAverage || zero,
          sRedZonePassing: ele.sRedZonePassing || zero,
          sResults: ele.sResults || zero,
          sRushing0: ele.sRushing0 || zero,
          sRushing10: ele.sRushing10 || zero,
          sRushing20: ele.sRushing20 || zero,
          sRushing30: ele.sRushing30 || zero,
          sRushing40: ele.sRushing40 || zero,
          sRushing50: ele.sRushing50 || zero,
          sRushingAttempts: ele.sRushingAttempts || zero,
          sRushingLeft: ele.sRushingLeft || zero,
          sRushingLongest: ele.sRushingLongest || zero,
          sRushingMiddle: ele.sRushingMiddle || zero,
          sRushingNegative: ele.sRushingNegative || zero,
          sRushingNetYardsAverage: ele.sRushingNetYardsAverage || zero,
          sRushingRight: ele.sRushingRight || zero,
          sRushingTouchdowns: ele.sRushingTouchdowns || zero,
          sRushingYardsGain: ele.sRushingYardsGain || zero,
          sRushingYardsLoss: ele.sRushingYardsLoss || zero,
          sRushingYardsNet: ele.sRushingYardsNet || zero,
          sRushingYardsNetAverage: ele.sRushingYardsNetAverage || zero,
          sSacksAssisted: ele.sSacksAssisted || zero,
          sSacksTotal: ele.sSacksTotal || zero,
          sSacksUnassisted: ele.sSacksUnassisted || zero,
          sSacksYards: ele.sSacksYards || zero,
          sSafetiesOnePoint: ele.sSafetiesOnePoint || zero,
          sSafetiesTwoPoints: ele.sSafetiesTwoPoints || zero,
          sTacklesAssisted: ele.sTacklesAssisted || zero,
          sTacklesForcedFumble: ele.sTacklesForcedFumble || zero,
          sTacklesForLossAssisted: ele.sTacklesForLossAssisted || zero,
          sTacklesForLossSolo: ele.sTacklesForLossSolo || zero,
          sTacklesForLossTotal: ele.sTacklesForLossTotal || zero,
          sTacklesFumble: ele.sTacklesFumble || zero,
          sTacklesInterception: ele.sTacklesInterception || zero,
          sTacklesKickoff: ele.sTacklesKickoff || zero,
          sTacklesKickoffReturn: ele.sTacklesKickoffReturn || zero,
          sTacklesPassing: ele.sTacklesPassing || zero,
          sTacklesPunt: ele.sTacklesPunt || zero,
          sTacklesPuntReturn: ele.sTacklesPuntReturn || zero,
          sTacklesRushing: ele.sTacklesRushing || zero,
          sTacklesSolo: ele.sTacklesSolo || zero,
          sTacklesTotal: ele.sTacklesTotal || zero,
          sTacklesYards: ele.sTacklesYards || zero,
          sTakeaways: ele.sTakeaways || zero,
          sTouchdowns: ele.sTouchdowns || zero,
          sTurnoversCaused: ele.sTurnoversCaused || zero,
          sTurnoversCommitted: ele.sTurnoversCommitted || zero,
          sWins: ele.sWins || zero,
          sWinsAverage: ele.sWinsAverage || zero,
          sYardsAllPurposeTotal: ele.sYardsAllPurposeTotal || zero,
          sYardsOffensiveTotal: ele.sYardsOffensiveTotal || zero,
          sYardsOffensiveTotalAverage: ele.sYardsOffensiveTotalAverage || zero,
          sYardsPerPlayAverage: ele.sYardsPerPlayAverage || zero,
        };

        if (Object.keys(ele).find((ele) => /edited/gim.test(ele))) {
          sequence_data.s1stDownAttemptsedited = true;
        }

        samplec.push(sequence_data);
      }

      return resolve(samplec);
    });
  };

  onClick = async () => {
    if (this.state.importData) {
      if (
        checkNullAndReturnString(this.state.school) &&
        Number(this.state.school) !== 0
      ) {
        // if (
        //   checkNullAndReturnString(this.state.schoolId) &&
        //   Number(this.state.schoolId) !== 0
        // ) {
        // this.setState({ loading: true })
        var accessToken = localStorage.getItem("accessToken");
        var successText = false;
        var successCount = 0;
        var successMsg = "";

        for (let index = 0; this.state.tableData.length > 0; index += 5000) {
          const payload = this.state.tableData.splice(0, 5000);
          const uniquePlayers = await [
            ...new Map(
              payload.map((item) => [item["person_id"], item])
            ).values(),
          ];
          // .map(e => ({...e,first_name:'',last_name:''}));

          // console.log({
          //     uniquePlayers
          // })

          // return
          var postJson = {
            playerDetails: uniquePlayers,
            academicYear: this.state.school,
            schoolId: "",
          };
          var responseData = await doPostConnectSecurity(
            "ncaa-player-statistics",
            postJson,
            accessToken
          );
          if (checkNullAndReturnString(responseData)) {
            if (
              checkNullAndReturnString(responseData.message) &&
              responseData.message === "Success"
            ) {
              successText = true;
              var currentLength = parseInt(Object.keys(uniquePlayers).length);
              successCount = successCount + currentLength;
              successMsg = " Player records has been saved successfully";
              // this.setState({ loading: false })
              // toast.success("Player data has been saved successfully");
              // this.setState({ draftData: false })
              // this.emptyData();
            } else {
              if (checkNullAndReturnString(responseData.error)) {
                if (checkNullAndReturnString(responseData.error.message)) {
                  let error = responseData.error.message;
                  if (error && Array.isArray(error)) {
                    error = error.join(",");
                  }
                  toast.error(error || "Error while inserting datas");
                  // if (!successText) {
                  // successMsg = responseData.error.message;
                  // }
                }
              }
              // this.setState({ loading: false })
            }
          } else {
            this.setState({ loading: false });
          }
        }
        if (successText) {
          this.setState({ loading: false });
          toast.success(successCount + successMsg);
          this.setState({ draftData: false });
          this.emptyData();
        } else {
          toast.error(successMsg);
        }
        // } else {
        //   toast.error("Please select school");
        // }
      } else {
        toast.error("Please select academic year");
      }
    } else {
      toast.error("Please import data");
    }
  };

  tableHandleChange = (val, key, index, tablerow) => {
    // if (!(/^[0-9]*$/gmi.test(val))) {
    //     return
    // }
    var { tableData, tableLoadData } = this.state;
    tableLoadData[key][index] = val;
    tableLoadData[key][index + "edited"] = true;
    tableData[tablerow.id - 1][index] = val;
    tableData[tablerow.id - 1][index + "edited"] = true;
    // tableData[key]["editable"] = true;
    this.setState({ tableData, tableLoadData });
  };

  setImportdata = () => {
    this.setState((pre) => {
      const { sampleSelectedData, modalpaginations } = pre;
      const sampleDataToLoad = [...sampleSelectedData];
      const { paginatonpageindex, paginationrowsPerPage } = modalpaginations;
      const pagefrom = paginationrowsPerPage * paginatonpageindex;
      const pageto = paginationrowsPerPage;
      const loadslicedata1 = sampleDataToLoad.slice(0, pagefrom + pageto);
      const loadslicedata = [...loadslicedata1].splice(
        pagefrom,
        loadslicedata1.length
      );
      // const loadslicedata = loadslicedata1.slice(-Math.abs(pageto));
      return {
        ...pre,
        tableLoadData: loadslicedata,
        tableData: sampleSelectedData,
        importData: true,
        modalpaginations: {
          ...pre.modalpaginations,
          paginationcountdata: sampleDataToLoad.length,
        },
      };
    });
  };

  handleChangePage = async (event, newPage) => {
    const paginationvalue = {
      ...this.state.modalpaginations,
      paginatonpageindex: newPage,
    };
    this.setState(
      {
        modalpaginations: { ...paginationvalue },
      },
      this.setImportdata
    );
  };

  handleChangeRowsPerPage = async (event) => {
    const paginationvalue = {
      ...this.state.modalpaginations,
      paginationrowsPerPage: event.target.value,
      paginatonpageindex: 0,
    };
    this.setState(
      {
        modalpaginations: { ...paginationvalue },
      },
      this.setImportdata
    );
  };

  render() {
    const { classes } = this.props;
    var { academicYear } = this.state;
    // var tableInputStyle = {
    //     background: "transparent",
    //     font: "normal normal normal 14px/21px Poppins",
    //     height: 32,
    //     color: "#fff",
    //     border: "0.5px solid rgb(75 76 92 / 60%)",
    //     width: 80,
    //     paddingLeft: 13,
    //     paddingRight: 13,
    //     outline: "none",
    //     "&:hover": {
    //         outline: "none"
    //     },
    //     "&:focus": {
    //         outline: "none"
    //     },
    //     borderRadius: 5
    // }
    return (
      <React.Fragment>
        {this.state.loading ? <Loading /> : ""}
        <div
          class="row rowView"
          style={{
            paddingTop: 20,
            paddingBottom: window.innerWidth < 500 ? 110 : 50,
          }}
        >
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
            <span className={classes.searchText}>Import Player Statistics</span>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className={"row"}>
              <div
                class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12"
                style={{ paddingTop: 20 }}
              >
                <SelectBox
                  fullWidth={true}
                  extraStyle={{ width: "100%" }}
                  backgroundColor={"rgb(75 76 92 / 60%)"}
                  onChange={this.handleChange}
                  keyName={"school"}
                  options={academicYear}
                  value={this.state.school}
                />
              </div>
              <div
                class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
                style={{ paddingTop: 20 }}
              >
                <Button
                  buttonStyle={classes.buttonStyle1}
                  buttonName={"IMPORT"}
                  fullWidth={false}
                  onClick={this.importDataStatistics}
                />
                <Button
                  extraStyle={{ marginLeft: 20 }}
                  buttonStyle={classes.buttonStyle1}
                  buttonName={"EXPORT"}
                  fullWidth={false}
                  onClick={this.exportDataStatistics}
                />
              </div>
            </div>
            <div className={"row"}>
              <div
                class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12"
                style={{ paddingTop: 20 }}
              ></div>
            </div>
          </div>
          {/* <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            style={{ paddingTop: 10 }}
          >
            <span className={classes.studentCountText}>
              {checkNullAndReturnString(sampleSelectedData) &&
              Object.keys(sampleSelectedData).length > 0 &&
              importData
                ? Object.keys(sampleSelectedData).length +
                  " records imported successfully"
                : null}
            </span>
          </div> */}
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
            style={{ paddingTop: 10 }}
          >
            {/* <Tables
              tableHandleChange={this.tableHandleChange}
              // paginationFooter={this.state.modalpaginations}
              // handleChangePage={this.handleChangePage}
              // handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              from={"statistics"}
              fixed={true}
              extraStyle={{
                height:
                  checkNullAndReturnString(tableLoadData) &&
                  Object.keys(tableLoadData).length > 0
                    ? Object.keys(tableLoadData).length > 10
                      ? 400
                      : ""
                    : "",
              }}
              // thJson={["S.No","first_name", "last_name", "team", "academic_year", "class", "position", "person_id", "city", "state", "sport", "school_id", "teamName", "teamId", "gender", "dob", "familyName", "personName", "personNameInternational", "personGsId", "TVName", "scoreboardName", "website", "nickName", "internationalReference", "internationalFirstName", "internationalFamilyName", "defaultShirtNumber", "defaultPlayingPosition", "personExternalId", "s1stDownAttempts", "s1stDownConversions", "s2ndDownAttempts", "s2ndDownConversions", "s3rdDownAttempts", "s3rdDownConversionPassing", "s3rdDownConversionPenalty", "s3rdDownConversionRushing", "s3rdDownConversions", "s4thDownAttempts", "s4thDownConversionPassing", "s4thDownConversionPenalty", "s4thDownConversionRushing", "s4thDownConversions", "sDefensiveExtraPoints", "sDefensiveExtraPointsAttempts", "sDraws", "sDrawsAverage", "sEfficiency", "sEfficiencyCustom", "sFieldGoalAttemptLongest", "sFieldGoalAttempts1to19", "sFieldGoalAttempts20to29", "sFieldGoalAttempts30to39", "sFieldGoalAttempts40to49", "sFieldGoalAttempts50to59", "sFieldGoalAttempts60Plus", "sFieldGoalMadeLongest", "sFieldGoalReturns", "sFieldGoalsAttempted", "sFieldGoalsBlocked", "sFieldGoalsBlockedBy", "sFieldGoalsMade", "sFieldGoalsMade1to19", "sFieldGoalsMade20to29", "sFieldGoalsMade30to39", "sFieldGoalsMade40to49", "sFieldGoalsMade50to59", "sFieldGoalsMade60Plus", "sFieldGoalsPercentage", "sFirstDownPassing", "sFirstDownPenalty", "sFirstDownRushing", "sFirstDownTotal", "sForfeitsAgainst", "sForfeitsAgainstAverage", "sForfeitsFor", "sForfeitsForAverage", "sFumbleReturnLongest", "sFumbleReturnTotal", "sFumbleReturnTouchdowns", "sFumbleReturnYards", "sFumbleReturnYardsAverage", "sFumblesForced", "sFumblesLost", "sFumblesRecovered", "sFumblesTotal", "sGames", "sGamesStarted", "sGamesStartedAverage", "sGamesTeam", "sGamesTeamAverage", "sGamesTeamPercentage", "sGamesTeamPercentageAverage", "sGoalEfficiencyAttempt", "sGoalEfficiencyFieldGoal", "sGoalEfficiencyPercentage", "sGoalEfficiencyTouchdowns", "sInterceptionsAverage", "sInterceptionsReturnLongest", "sInterceptionsReturnYards", "sInterceptionsTouchdowns", "sKickoffsGrossAverage", "sKickoffsGrossYards", "sKickoffsNetAverage", "sKickoffsNetYards", "sKickoffsOutOfBound", "sKickoffsReturned", "sKickoffsTotal", "sKickoffsTouchbacks", "sKickOnSideAttempts", "sKickReturnsAverage", "sKickReturnsLongest", "sKickReturnsTotal", "sKickReturnsTouchdowns", "sKickReturnsYards", "sKicksBlocked", "sKicksBlockedBy", "sKicksOnSide", "sLosses", "sLossesAverage", "sMinutes", "sMinutesAverage", "sPassBreakUps", "sPassEfficiency", "sPasses", "sPassesAverageYardsPerCompletion", "sPassesCompleted", "sPassesIntercepted", "sPassesInterceptionPercentage", "sPassesLeft", "sPassesLongest", "sPassesMiddle", "sPassesPercentage", "sPassesRight", "sPassesSacked", "sPassesTouchDownPercentage", "sPassesTouchdowns", "sPassesYards", "sPassesYardsAverage", "sPassesYardsPerAttempt", "sPassesYardsPerCatch", "sPassesYardsSacked", "sPassIncompleteDropped", "sPassing0", "sPassing10", "sPassing20", "sPassing30", "sPassing40", "sPassing50", "sPassingNegative", "sPassInterceptions", "sPassQuarterbackHurries", "sPatAttempts", "sPatBlockedKicks", "sPatBlockedKicksBy", "sPatFumbleReturnConversions", "sPatFumbleReturns", "sPatInterceptionReturnConversions", "sPatInterceptionReturns", "sPatKickReturnConversions", "sPatKickReturns", "sPatKicksAttempted", "sPatKicksMade", "sPatKicksPercentage", "sPatMade", "sPatPassAttempts", "sPatPasses", "sPatPercentage", "sPatReceives", "sPatRushAttempts", "sPatRushes", "sPatSafetyConversions", "sPatTwoPointsAttempt", "sPatTwoPointsMade", "sPenalty", "sPenaltyYards", "sPlaysAllPurposeTotal", "sPlaysTotal", "sPoints", "sPointsAverage", "sPuntReturns", "sPuntReturns0", "sPuntReturns10", "sPuntReturns20", "sPuntReturns30", "sPuntReturns40", "sPuntReturns50", "sPuntReturnsAverage", "sPuntReturnsLongest", "sPuntReturnsTouchdown", "sPuntReturnsYards", "sPunts", "sPunts50plus", "sPuntsAverage", "sPuntsBlocked", "sPuntsBlockedBy", "sPuntsFairCatches", "sPuntsInside20", "sPuntsLongest", "sPuntsNetAverage", "sPuntsTouchbacks", "sPuntsYards", "sPuntsYardsNet", "sReceiving0", "sReceiving10", "sReceiving20", "sReceiving30", "sReceiving40", "sReceiving50", "sReceivingNegative", "sReceptions", "sReceptionsAverage", "sReceptionsLongest", "sReceptionsTouchdown", "sReceptionsYards", "sReceptionsYardsAfterCatch", "sReceptionsYardsAverage", "sRedZonePassing", "sResults", "sRushing0", "sRushing10", "sRushing20", "sRushing30", "sRushing40", "sRushing50", "sRushingAttempts", "sRushingLeft", "sRushingLongest", "sRushingMiddle", "sRushingNegative", "sRushingNetYardsAverage", "sRushingRight", "sRushingTouchdowns", "sRushingYardsGain", "sRushingYardsLoss", "sRushingYardsNet", "sRushingYardsNetAverage", "sSacksAssisted", "sSacksTotal", "sSacksUnassisted", "sSacksYards", "sSafetiesOnePoint", "sSafetiesTwoPoints", "sTacklesAssisted", "sTacklesForcedFumble", "sTacklesForLossAssisted", "sTacklesForLossSolo", "sTacklesForLossTotal", "sTacklesFumble", "sTacklesInterception", "sTacklesKickoff", "sTacklesKickoffReturn", "sTacklesPassing", "sTacklesPunt", "sTacklesPuntReturn", "sTacklesRushing", "sTacklesSolo", "sTacklesTotal", "sTacklesYards", "sTakeaways", "sTouchdowns", "sTurnoversCaused", "sTurnoversCommitted", "sWins", "sWinsAverage", "sYardsAllPurposeTotal", "sYardsOffensiveTotal", "sYardsOffensiveTotalAverage", "sYardsPerPlayAverage"]}

              thJson={[
                "S.No",
                "First Name",
                "Last Name",
                "Academic Year",
                "Class",
                "Position",
                "Person Id",
                "City",
                "State",
                "Sport",
                "Team Name",
                "Team Id",
                "Family Name",
                "Person Name",
                "Default Shirt Number",
                "Default Playing Position",
                "Person External Id",
                "s1stDownAttempts",
                "s1stDownConversions",
                "s2ndDownAttempts",
                "s2ndDownConversions",
                "s3rdDownAttempts",
                "s3rdDownConversionPassing",
                "s3rdDownConversionPenalty",
                "s3rdDownConversionRushing",
                "s3rdDownConversions",
                "s4thDownAttempts",
                "s4thDownConversionPassing",
                "s4thDownConversionPenalty",
                "s4thDownConversionRushing",
                "s4thDownConversions",
                "sDefensiveExtraPoints",
                "sDefensiveExtraPointsAttempts",
                "sDraws",
                "sDrawsAverage",
                "sEfficiency",
                "sEfficiencyCustom",
                "sFieldGoalAttemptLongest",
                "sFieldGoalAttempts1to19",
                "sFieldGoalAttempts20to29",
                "sFieldGoalAttempts30to39",
                "sFieldGoalAttempts40to49",
                "sFieldGoalAttempts50to59",
                "sFieldGoalAttempts60Plus",
                "sFieldGoalMadeLongest",
                "sFieldGoalReturns",
                "sFieldGoalsAttempted",
                "sFieldGoalsBlocked",
                "sFieldGoalsBlockedBy",
                "sFieldGoalsMade",
                "sFieldGoalsMade1to19",
                "sFieldGoalsMade20to29",
                "sFieldGoalsMade30to39",
                "sFieldGoalsMade40to49",
                "sFieldGoalsMade50to59",
                "sFieldGoalsMade60Plus",
                "sFieldGoalsPercentage",
                "sFirstDownPassing",
                "sFirstDownPenalty",
                "sFirstDownRushing",
                "sFirstDownTotal",
                "sForfeitsAgainst",
                "sForfeitsAgainstAverage",
                "sForfeitsFor",
                "sForfeitsForAverage",
                "sFumbleReturnLongest",
                "sFumbleReturnTotal",
                "sFumbleReturnTouchdowns",
                "sFumbleReturnYards",
                "sFumbleReturnYardsAverage",
                "sFumblesForced",
                "sFumblesLost",
                "sFumblesRecovered",
                "sFumblesTotal",
                "sGames",
                "sGamesStarted",
                "sGamesStartedAverage",
                "sGamesTeam",
                "sGamesTeamAverage",
                "sGamesTeamPercentage",
                "sGamesTeamPercentageAverage",
                "sGoalEfficiencyAttempt",
                "sGoalEfficiencyFieldGoal",
                "sGoalEfficiencyPercentage",
                "sGoalEfficiencyTouchdowns",
                "sInterceptionsAverage",
                "sInterceptionsReturnLongest",
                "sInterceptionsReturnYards",
                "sInterceptionsTouchdowns",
                "sKickoffsGrossAverage",
                "sKickoffsGrossYards",
                "sKickoffsNetAverage",
                "sKickoffsNetYards",
                "sKickoffsOutOfBound",
                "sKickoffsReturned",
                "sKickoffsTotal",
                "sKickoffsTouchbacks",
                "sKickOnSideAttempts",
                "sKickReturnsAverage",
                "sKickReturnsLongest",
                "sKickReturnsTotal",
                "sKickReturnsTouchdowns",
                "sKickReturnsYards",
                "sKicksBlocked",
                "sKicksBlockedBy",
                "sKicksOnSide",
                "sLosses",
                "sLossesAverage",
                "sMinutes",
                "sMinutesAverage",
                "sPassBreakUps",
                "sPassEfficiency",
                "sPasses",
                "sPassesAverageYardsPerCompletion",
                "sPassesCompleted",
                "sPassesIntercepted",
                "sPassesInterceptionPercentage",
                "sPassesLeft",
                "sPassesLongest",
                "sPassesMiddle",
                "sPassesPercentage",
                "sPassesRight",
                "sPassesSacked",
                "sPassesTouchDownPercentage",
                "sPassesTouchdowns",
                "sPassesYards",
                "sPassesYardsAverage",
                "sPassesYardsPerAttempt",
                "sPassesYardsPerCatch",
                "sPassesYardsSacked",
                "sPassIncompleteDropped",
                "sPassing0",
                "sPassing10",
                "sPassing20",
                "sPassing30",
                "sPassing40",
                "sPassing50",
                "sPassingNegative",
                "sPassInterceptions",
                "sPassQuarterbackHurries",
                "sPatAttempts",
                "sPatBlockedKicks",
                "sPatBlockedKicksBy",
                "sPatFumbleReturnConversions",
                "sPatFumbleReturns",
                "sPatInterceptionReturnConversions",
                "sPatInterceptionReturns",
                "sPatKickReturnConversions",
                "sPatKickReturns",
                "sPatKicksAttempted",
                "sPatKicksMade",
                "sPatKicksPercentage",
                "sPatMade",
                "sPatPassAttempts",
                "sPatPasses",
                "sPatPercentage",
                "sPatReceives",
                "sPatRushAttempts",
                "sPatRushes",
                "sPatSafetyConversions",
                "sPatTwoPointsAttempt",
                "sPatTwoPointsMade",
                "sPenalty",
                "sPenaltyYards",
                "sPlaysAllPurposeTotal",
                "sPlaysTotal",
                "sPoints",
                "sPointsAverage",
                "sPuntReturns",
                "sPuntReturns0",
                "sPuntReturns10",
                "sPuntReturns20",
                "sPuntReturns30",
                "sPuntReturns40",
                "sPuntReturns50",
                "sPuntReturnsAverage",
                "sPuntReturnsLongest",
                "sPuntReturnsTouchdown",
                "sPuntReturnsYards",
                "sPunts",
                "sPunts50plus",
                "sPuntsAverage",
                "sPuntsBlocked",
                "sPuntsBlockedBy",
                "sPuntsFairCatches",
                "sPuntsInside20",
                "sPuntsLongest",
                "sPuntsNetAverage",
                "sPuntsTouchbacks",
                "sPuntsYards",
                "sPuntsYardsNet",
                "sReceiving0",
                "sReceiving10",
                "sReceiving20",
                "sReceiving30",
                "sReceiving40",
                "sReceiving50",
                "sReceivingNegative",
                "sReceptions",
                "sReceptionsAverage",
                "sReceptionsLongest",
                "sReceptionsTouchdown",
                "sReceptionsYards",
                "sReceptionsYardsAfterCatch",
                "sReceptionsYardsAverage",
                "sRedZonePassing",
                "sResults",
                "sRushing0",
                "sRushing10",
                "sRushing20",
                "sRushing30",
                "sRushing40",
                "sRushing50",
                "sRushingAttempts",
                "sRushingLeft",
                "sRushingLongest",
                "sRushingMiddle",
                "sRushingNegative",
                "sRushingNetYardsAverage",
                "sRushingRight",
                "sRushingTouchdowns",
                "sRushingYardsGain",
                "sRushingYardsLoss",
                "sRushingYardsNet",
                "sRushingYardsNetAverage",
                "sSacksAssisted",
                "sSacksTotal",
                "sSacksUnassisted",
                "sSacksYards",
                "sSafetiesOnePoint",
                "sSafetiesTwoPoints",
                "sTacklesAssisted",
                "sTacklesForcedFumble",
                "sTacklesForLossAssisted",
                "sTacklesForLossSolo",
                "sTacklesForLossTotal",
                "sTacklesFumble",
                "sTacklesInterception",
                "sTacklesKickoff",
                "sTacklesKickoffReturn",
                "sTacklesPassing",
                "sTacklesPunt",
                "sTacklesPuntReturn",
                "sTacklesRushing",
                "sTacklesSolo",
                "sTacklesTotal",
                "sTacklesYards",
                "sTakeaways",
                "sTouchdowns",
                "sTurnoversCaused",
                "sTurnoversCommitted",
                "sWins",
                "sWinsAverage",
                "sYardsAllPurposeTotal",
                "sYardsOffensiveTotal",
                "sYardsOffensiveTotalAverage",
                "sYardsPerPlayAverage",
              ]}
              tdJson={importData ? tableLoadData : []}
            /> */}
            {/* <div>
              <TablePagination
                style={{ color: "white" }}
                component="div"
                count={paginationcountdata}
                page={paginatonpageindex}
                onChangePage={this.handleChangePage}
                rowsPerPage={paginationrowsPerPage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                rowsPerPageOptions={[50, 100, 150, 200]}
              />
            </div> */}
          </div>
          {/* {checkNullAndReturnString(tableLoadData) &&
          Object.keys(tableLoadData).length > 0 &&
          importData ? (
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              style={{ paddingTop: 20 }}
            >
              <div style={{ float: "right", paddingTop: 0 }}>               
                <Button
                  buttonStyle={classes.buttonStyle}
                  buttonName={"Submit"}
                  fullWidth={false}
                  onClick={this.onOpenModal}
                />
              </div>
            </div>
          ) : (
            ""
          )} */}
        </div>
        <Modal
          open={this.state.exportModal}
          onClose={() => this.setState({ exportModal: false })}
          center
          showCloseIcon={false}
        >
          <div style={{ padding: 20 }}>
            <p
              style={{
                font: "normal normal 600 18px/27px Poppins",
                opacity: 1,
              }}
            >
              Export
            </p>
            <p
              style={{
                font: "normal normal normal 14px/21px Poppins",
                opacity: 1,
              }}
            >
              Data export is inprogress. You will be notified through your
              registered email once export is completed.
            </p>
            <p style={{ float: "right" }}>
              <Button
                buttonStyle={classes.buttonStyle3}
                buttonName={"Ok"}
                fullWidth={false}
                onClick={() => {
                  this.setState({ exportModal: false });
                }}
              />
            </p>
          </div>
        </Modal>
        <Modal
          open={this.state.showNotifyModal}
          onClose={() => this.setState({ showNotifyModal: false })}
          center
          showCloseIcon={false}
        >
          <div style={{ padding: 20 }}>
            <p
              style={{
                font: "normal normal 600 18px/27px Poppins",
                opacity: 1,
              }}
            >
              Import
            </p>
            <p
              style={{
                font: "normal normal normal 14px/21px Poppins",
                opacity: 1,
              }}
            >
              Data import is inprogress. You will be notified through your
              registered email once import is completed.
            </p>
            <p style={{ float: "right" }}>
              <Button
                buttonStyle={classes.buttonStyle3}
                buttonName={"Ok"}
                fullWidth={false}
                onClick={() => {
                  this.setState({ showNotifyModal: false });
                }}
              />
            </p>
          </div>
        </Modal>
        {/* <Modal
          open={this.state.modal}
          onClose={() => this.onCloseModal()}
          center
          showCloseIcon={false}
        >
          <div style={{ padding: 20 }}>
            <p
              style={{
                font: "normal normal 600 18px/27px Poppins",
                opacity: 1,
              }}
            >
              Import Data Confirmation
            </p>
            <p
              style={{
                font: "normal normal normal 14px/21px Poppins",
                opacity: 1,
              }}
            >
              All previous imported data will be replaced, are you sure you want
              to proceed?
            </p>
            <p style={{ float: "right" }}>
              <Button
                buttonStyle={classes.buttonStyle2}
                buttonName={"Cancel"}
                fullWidth={false}
                onClick={() => {
                  this.onCloseModal();
                }}
              />
              <span style={{ paddingRight: 20 }}></span>
              <Button
                buttonStyle={classes.buttonStyle3}
                buttonName={"Confirm"}
                fullWidth={false}
                onClick={() => {
                  this.onClick();
                  this.onCloseModal();
                }}
              />
            </p>
          </div>
        </Modal> */}
      </React.Fragment>
    );
  }
}
export default withStyles(Styles, { withTheme: true })(
  withStore(ImportStatistics)
);
